import { Card, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { isRootCauseWorkspace } from "..";
import PeriodSelector from "../../../../components/common/PeriodSelector";
import { useFiltersRegistry } from "../../../../context/FiltersProvider";
import { RootCauseCardType } from "../data";
import { getRootCauseCardIcon } from "../RootCauseCard";
import { CardDashboardReadonly } from "./CardDashboardReadonly";

type Props = {
	id: RootCauseCardType;
};

export const RootCauseCardReadOnly = ({ id }: Props) => {
	const { t } = useTranslation("whatif.rootcause");
	const { rootCauseState } = useFiltersRegistry();

	const period = isRootCauseWorkspace(id) ? rootCauseState.periods[id] : undefined;

	return (
		<Card sx={{ padding: 2 }}>
			<Stack direction="row" justifyContent="space-between" alignItems="center" marginBottom={2}>
				<Stack direction="row" spacing={1} alignItems="center">
					{getRootCauseCardIcon(id)}
					<Typography variant="h6" fontWeight={500}>
						{t(`cardTitles/${id}`)}
					</Typography>
				</Stack>

				{period && (
					<PeriodSelector filter={period} setFilter={(period) => {}} variant="simple" readOnly={true} />
				)}
			</Stack>

			<CardDashboardReadonly cardType={id} />
		</Card>
	);
};
